module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('animate-number', {
    attrs: {
      "number": _vm.val
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-82d0f67a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/animate-number/demo.vue
// module id = 272
// module chunks = 32